var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LegendButton',{staticClass:"legend-btn"}),_c('CurrentPositionButton',{staticClass:"current-position-btn"}),_c('RefineSettingPanel',{staticClass:"refine-setting-panel"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }